import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-12% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SplitLines = ({ lines, className = "", delay = 0, stagger = 0.11, inView = false, as = "h1", ...rest }) => {
  const Tag = motion[as];
  const anim = inView
    ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } }
    : { animate: "show" };
  return (
    <Tag className={className} initial="hidden" {...anim} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            variants={{ hidden: { y: "110%", rotate: 2 }, show: { y: "0%", rotate: 0 } }}
            transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
          {i < lines.length - 1 && " "}
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, className = "", ...rest }) => (
  <Reveal y={16} className={`eyebrow ${className}`} {...rest}>
    {children}
  </Reveal>
);
